import { API_URL_DEV, API_URL_PROD, DASHBOARD_LOGIN_LINK } from './constants';

const ipCheck = (hostname: string): boolean => {
    const host = hostname.split('.');
    return host.every(block => Number(block) >= 0 && Number(block) < 255);
};

const hostname = window.location.hostname;
const origin = window.location.origin;

// Split out the environment from the url: dashboard.[dev-env].airthings.com --> [dev-env]
const hostnameRegex = hostname.match(new RegExp('accounts(.*?).airthings'));
const prodEnvPrefix = hostnameRegex && hostnameRegex.length > 1 ? hostnameRegex[1] : '';
// need to check for hostname accounts-ng.dev.airthings.com as this will default to return ng.dev as prefix.
const envPrefix =
    hostname === 'localhost' || hostname === 'accounts-ng.dev.airthings.com' || ipCheck(hostname)
        ? 'dev'
        : prodEnvPrefix.substr(1);
const env = envPrefix ? 'DEV' : 'PROD';

const apiUrl = envPrefix ? API_URL_DEV.replace('{{environment}}', envPrefix) : API_URL_PROD;

export const cookieDomain = hostname === 'localhost' ? 'localhost' : '.airthings.com';
const dashboardLoginLink = `${origin}${DASHBOARD_LOGIN_LINK}`;

const config = {
    apiUrl,
    env,
    cookieDomain,
    dashboardLoginLink,
};

export default config;
